import classNames from 'classnames';
import React, { PureComponent } from 'react';

import Dropdown from '@commons/Dropdown';
import Question from '@commons/Question';

import layoutStyles from '@css/layout.scss';

import styles from './singleDropdown.scss';

interface SingleDropdownProps {
  formkey?: string;
  caption?: string;
  alt?: unknown[];
  validationEmpty?: string;
  validationFailed?: string;
  requiredField?: string;
  isMultiValued?: boolean;
  isSubComponent?: boolean;
  id: number;
  onChange: (...args: unknown[]) => unknown;
  selected?: unknown | unknown[];
}

export class SingleDropdown extends PureComponent<SingleDropdownProps> {
  static defaultProps = {
    formkey: '',
    caption: '',
    alt: [],
    validationEmpty: '',
    validationFailed: '',
    requiredField: '',
    selected: undefined,
    isSubComponent: false,
    isMultiValued: false
  };

  render() {
    const {
      formkey,
      caption,
      validationEmpty,
      validationFailed,
      requiredField,
      alt,
      selected,
      isSearchable,
      isMultiValued,
      isRTL,
      isSubComponent
    } = this.props;

    const elementId = `dropdown-${formkey}`;
    const { id: selectedId = '' } = selected || {};

    const mainContainerStyles = classNames({ [styles.subComponentMainContainer]: isSubComponent });
    const fieldsetStyles = classNames({ [styles.subComponentFieldset]: isSubComponent });
    const dropdownWrapperStyles = classNames({ [layoutStyles.answers]: !isSubComponent });
    const containerStyles = classNames(layoutStyles.answer, styles.dropdownWrapper, {
      [styles.subComponentDropdown]: isSubComponent
    });

    return (
      <div className={`questionBlock singleDropdownQuestion ${mainContainerStyles}`}>
        <fieldset className={fieldsetStyles}>
          {!isSubComponent && (
            <Question
              caption={caption}
              validationEmpty={validationEmpty}
              validationFailed={validationFailed}
              requiredField={requiredField}
            />
          )}
          <div className={dropdownWrapperStyles}>
            <Dropdown
              elementId={elementId}
              containerStyles={containerStyles}
              dropdownList={alt}
              isMultiValued={isMultiValued}
              selected={selected}
              onChange={this.props.onChange}
              title={caption}
              isSubComponent={isSubComponent}
              isSearchable={isSearchable}
              isRTL={isRTL}
            />
            {isMultiValued ? (
              selected.map((item) => (
                <input key={item.id} type="hidden" id={formkey} name={formkey} value={item.id} />
              ))
            ) : (
              <input type="hidden" id={formkey} name={formkey} value={selectedId} />
            )}
          </div>
        </fieldset>
      </div>
    );
  }
}

export default SingleDropdown;
// TODO: Consider tracking with RUM.
// export default withQuestionMeasurement(SingleDropdown, 'dropdown');
